export class CommonConstant {
  public static Routes = {
    Landing: '',
    Login:'login',
    ConnectionError: 'connectionerror',
    BankSelection: 'bankselection',
    AccountSelection: 'accountselection',
    CustomerConsent: 'customerconsent',
    CustomerConsentApproval: 'consentapproval',
    CustomerApproval: 'customerapproval',
    ConsentSuccess: 'consent',
    ConsentError: 'error',
    LinkAccount: 'linkaccount',
    RouteNotFound: '**'
  }
  public static DataSharingKeys = {
    FINVUCLIENT: 'finvuClient',
    LINKEDACCOUNTDATA: 'linkedAccountDetails',
    LINKREFNUMBER: 'linkRefNumber'
  }
  public static StatusCode = {
    RECORD_NOT_FOUND: 'RECORD-NOT-FOUND',
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE',
    LINKED: 'LINKED',
    INCORRECT_OTP: 'Token incorrect.',
    SESSION_EXPIRED: '',
    INCCORECT_FINVU_OTP: 'Otp validation failed.',
    LOGIN_REQUIRED: 'Login Required'
  }
  public static ErrorMessages = {
    SDK_FAILURE: 'something went wrong , please try after some time.',
    INVALID_OTP: 'This OTP is invalid. Please re-enter the OTP or click on Resend OTP',
    SELECTION_ERROR:{
      2:'Please select atleast one account of each bank',
      1: 'Please select atleast one account'
    }

  }

  public static ThemeConfig = {
    theme: 'THEME',
    dark: 'DARK',
    light: 'LIGHT',
    themeDark: 'darkTheme',
    themeLight: 'whiteTheme',
  }
  public static journeyType = {
    NEWJOURNEY: true
  }
  // AEM URL's
  public static AEMURLs = {
    CompanyLogoImageUrl: '/content/dam/bajajfinserv/spa-banners/journey-peronal-loan/journey/BMarketsLogoReverse.png',
  };

  public static APIURL = {
    getBankList: `{DOMAIN01}/v2/smartsearch/banks?source=AASTANDALONE`,
    initiateAA:`{DOMAIN01}/v1/webBFF/initiateAA`
  }

  public static utmKeys={
    utm_source: 'Utm_source',
    utm_medium: 'Utm_medium',
    utm_campaign: 'Utm_campaign',
    utm_term: 'Utm_term',
    utm_content: 'Utm_content',
  }
  public static  CookieKeysAA ={
    authtoken:'authtoken'
  }
  public static setFinvuStorageKeys={
    mob:'mob',
    finvuconsentid:'finvuconsentid',
    finvucustomerid:'finvucustomerid',
    fipDetails:'fipDetails',
    applicationid:'applicationid',
    redirectionUrl: 'redirectionUrl',
    occupationIdentifier:'occupationIdentifier',
    productid:'productid',
    sourceChannel:'sourceChannel',
    source:'source',
    applicantid:'applicantid'

  }

}